/* Register the MangroveGuard service worker. */
export function registerSW() {
  if (!('serviceWorker' in navigator)) return;
  const isProd = process.env.NODE_ENV === 'production';
  const forceDev = process.env.REACT_APP_SW_DEV === '1';
  if (!isProd && !forceDev) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('mg-sw-update', { detail: reg }));
            }
          });
        });
      })
      .catch((err) => console.warn('SW registration failed', err));
  });
}

export function applySWUpdate(reg) {
  if (!reg?.waiting) return;
  reg.waiting.postMessage({ type: 'SKIP_WAITING' });
  reg.waiting.addEventListener('statechange', (e) => {
    if (e.target.state === 'activated') window.location.reload();
  });
}
